<template>
    <div>



<!-- <app-monev_topbar></app-monev_topbar>
<app-monev_left_sidebar></app-monev_left_sidebar> -->

<section class="content">
<div class="container-fluid">

       <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Modul Sakip</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons" title="Tambah Data">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th class="text-center" style="width: 80%">Nama Modul</th>
                            <th style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.modul_sakip_id">
                            <td class="text-center">{{index+1}}.</td>
                            <td>{{data.nama_modul}}</td>
                            
                            <td class="text-center" >
                                    <button @click="selectData(data)" type="button" class="btn bg-blue btn-xs waves-effect" id="lihat_dokumen"  data-toggle="modal" data-target="#m_lihat_data">
                                        <i class="material-icons" >search</i>
                                    </button>
                                    &nbsp;
                                    <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                        <i class="material-icons" >create</i>
                                    </button>
                                    &nbsp;
                                    <button @click="removeData(data.modul_sakip_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                        <i class="material-icons" >clear</i>
                                    </button>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>

                <hr>

        <!-- ============================================================ LIHAT DATA ======================================================================== -->
            <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-md" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-light-blue">
                            <h4 class="modal-title" id="largeModalLabel">DETIL DATA</h4>
                        </div>
                            <div class="modal-body">
                              <div class="table-responsive">
                                <!-- <div>
                                  <input type="checkbox" @change="check_pilihan" v-model="check_semua" id="check_semua" class="filled-in" ><label for="check_semua"><b>PILIH SEMUA</b></label> <br>
                                </div> -->
                                <input type="checkbox" v-model="dataku.registrator" id="registrator" class="filled-in" disabled><label for="registrator"><b>REGISTRASI USER</b></label> &nbsp; &nbsp;
                                <input type="checkbox" v-model="dataku.akses_semua_unit" id="check_semua" class="filled-in" disabled><label for="check_semua"><b>AKSES SEMUA UNIT KERJA</b></label> 
                                <hr>
                                <table style="width: 100%">
                                    <tr>
                                        <td style="width: 50%">
                                            <div class="demo-radio-button">
                                                <div class="demo-checkbox">
                                                    <input type="checkbox" v-model="dataku.delegasi_lv_1" id="delegasi_lv_1" class="filled-in" disabled><label for="delegasi_lv_1">Delegasi LV 1</label> <br>
                                                    <input type="checkbox" v-model="dataku.delegasi_lv_2" id="delegasi_lv_2" class="filled-in" disabled><label for="delegasi_lv_2">Delegasi LV 2</label><br>
                                                    <input type="checkbox" v-model="dataku.delegasi_lv_3" id="delegasi_lv_3" class="filled-in" disabled><label for="delegasi_lv_3">Delegasi LV 3</label><br>
                                                    <input type="checkbox" v-model="dataku.ra_lv_1" id="ra_lv_1" class="filled-in" disabled><label for="ra_lv_1">Rencana Aksi LV 1</label><br>
                                                </div>
                                            </div>
                                        </td>

                                        <td style="width: 50%">
                                            <div class="demo-radio-button">
                                                <div class="demo-checkbox">
                                                    <input type="checkbox" v-model="dataku.ra_lv_2" id="ra_lv_2" class="filled-in" disabled><label for="ra_lv_2">Rencana Aksi LV 2</label><br>
                                                    <input type="checkbox" v-model="dataku.ra_lv_3" id="ra_lv_3" class="filled-in" disabled><label for="ra_lv_3">Rencana Aksi LV 3</label> <br>
                                                    <input type="checkbox" v-model="dataku.realisasi" id="realisasi" class="filled-in" disabled><label for="realisasi">Realisasi</label><br>
                                                    <input type="checkbox" v-model="dataku.laporan" id="laporan" class="filled-in" disabled><label for="laporan">Laporan</label><br>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                               
                              </div>


                                
                            </div>
                                <hr>
                            <div class="modal-footer">
                                <!-- <button type="submit" class="btn btn-info waves-effect">SIMPAN</button> -->
                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                            </div>

                    </div>
                </div>
            </div>
        <!-- ============================================================ LIHAT DATA ======================================================================== -->



        <!-- ============================================================ TAMBAH DATA ======================================================================== -->
            <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop="static">
                <div class="modal-dialog modal-md" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-light-blue">
                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                        </div>
                          <form @submit.prevent="addData()">
                            <div class="modal-body">


                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Level</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="dataku.nama_modul" type="text" id="nilai" class="form-control" placeholder="Level User">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                                <div class="row clearfix">
                                  <div class="col-md-12">
                                        <div class="table-responsive">
                                            <div>
                                                <input type="checkbox" @change="check_pilihan" v-model="check_semua" id="check_semua_tambah" class="filled-in" ><label for="check_semua_tambah"><b>PILIH SEMUA</b></label> &nbsp; &nbsp;
                                                <input type="checkbox" v-model="dataku.registrator" id="registrator_tambah" class="filled-in" ><label for="registrator_tambah"><b>REGISTRASI USER</b></label> &nbsp; &nbsp;
                                                <input type="checkbox" v-model="dataku.akses_semua_unit" id="akses_semua_unit_tambah" class="filled-in" ><label for="akses_semua_unit_tambah"><b>AKSES SEMUA UNIT KERJA</b></label> 
                                            </div>
                                            <hr>
                                            <table style="width: 100%">
                                                <tr>
                                                    <td style="width: 50%">
                                                        <div class="demo-radio-button">
                                                            <div class="demo-checkbox">
                                                                <input type="checkbox" v-model="dataku.delegasi_lv_1" id="delegasi_lv_1_tambah" class="filled-in" ><label for="delegasi_lv_1_tambah">Delegasi LV 1</label> <br>
                                                                <input type="checkbox" v-model="dataku.delegasi_lv_2" id="delegasi_lv_2_tambah" class="filled-in" ><label for="delegasi_lv_2_tambah">Delegasi LV 2</label><br>
                                                                <input type="checkbox" v-model="dataku.delegasi_lv_3" id="delegasi_lv_3_tambah" class="filled-in" ><label for="delegasi_lv_3_tambah">Delegasi LV 3</label><br>
                                                                <input type="checkbox" v-model="dataku.ra_lv_1" id="ra_lv_1_tambah" class="filled-in" ><label for="ra_lv_1_tambah">Rencana Aksi LV 1</label><br>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td style="width: 50%">
                                                        <div class="demo-radio-button">
                                                            <div class="demo-checkbox">
                                                                <input type="checkbox" v-model="dataku.ra_lv_2" id="ra_lv_2_tambah" class="filled-in" ><label for="ra_lv_2_tambah">Rencana Aksi LV 2</label><br>
                                                                <input type="checkbox" v-model="dataku.ra_lv_3" id="ra_lv_3_tambah" class="filled-in" ><label for="ra_lv_3_tambah">Rencana Aksi LV 3</label> <br>
                                                                <input type="checkbox" v-model="dataku.realisasi" id="realisasi_tambah" class="filled-in" ><label for="realisasi_tambah">Realisasi</label><br>
                                                                <input type="checkbox" v-model="dataku.laporan" id="laporan_tambah" class="filled-in" ><label for="laporan_tambah">Laporan</label><br>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                        
                                  </div>
                                </div>

                                
                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                            </div>
                          </form>
                    </div>
                </div>
            </div>
        <!-- ============================================================ TAMBAH DATA ======================================================================== -->



        <!-- ============================================================ EDIT DATA ======================================================================== -->

            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog"  data-backdrop="static">
                <div class="modal-dialog modal-md" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-light-green">
                            <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                        </div>
                        <div class="modal-body">
                            <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Nama Level</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <input v-model="dataku.nama_modul" type="text" id="nilai" class="form-control" placeholder="Level User">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <div class="row clearfix">
                                <div class="col-md-12">
                                    <div class="table-responsive">
                                        <div>
                                            <input type="checkbox" @change="check_pilihan" v-model="check_semua" id="check_semua_edit" class="filled-in" ><label for="check_semua_edit"><b>PILIH SEMUA</b></label> &nbsp; &nbsp;
                                            <input type="checkbox" v-model="dataku.registrator" id="registrator_edit" class="filled-in" ><label for="registrator_edit"><b>REGISTRASI USER</b></label> &nbsp; &nbsp;
                                            <input type="checkbox" v-model="dataku.akses_semua_unit" id="akses_semua_unit_edit" class="filled-in" ><label for="akses_semua_unit_edit"><b>AKSES SEMUA UNIT KERJA</b></label> 
                                        </div>
                                        <hr>
                                        <table style="width: 100%">
                                            <tr>
                                                <td style="width: 50%">
                                                    <div class="demo-radio-button">
                                                        <div class="demo-checkbox">
                                                            <input type="checkbox" v-model="dataku.delegasi_lv_1" id="delegasi_lv_1_edit" class="filled-in" ><label for="delegasi_lv_1_edit">Delegasi LV 1</label> <br>
                                                            <input type="checkbox" v-model="dataku.delegasi_lv_2" id="delegasi_lv_2_edit" class="filled-in" ><label for="delegasi_lv_2_edit">Delegasi LV 2</label><br>
                                                            <input type="checkbox" v-model="dataku.delegasi_lv_3" id="delegasi_lv_3_edit" class="filled-in" ><label for="delegasi_lv_3_edit">Delegasi LV 3</label><br>
                                                            <input type="checkbox" v-model="dataku.ra_lv_1" id="ra_lv_1_edit" class="filled-in" ><label for="ra_lv_1_edit">Rencana Aksi LV 1</label><br>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td style="width: 50%">
                                                    <div class="demo-radio-button">
                                                        <div class="demo-checkbox">
                                                            <input type="checkbox" v-model="dataku.ra_lv_2" id="ra_lv_2_edit" class="filled-in" ><label for="ra_lv_2_edit">Rencana Aksi LV 2</label><br>
                                                            <input type="checkbox" v-model="dataku.ra_lv_3" id="ra_lv_3_edit" class="filled-in" ><label for="ra_lv_3_edit">Rencana Aksi LV 3</label> <br>
                                                            <input type="checkbox" v-model="dataku.realisasi" id="realisasi_edit" class="filled-in" ><label for="realisasi_edit">Realisasi</label><br>
                                                            <input type="checkbox" v-model="dataku.laporan" id="laporan_edit" class="filled-in" ><label for="laporan_edit">Laporan</label><br>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    
                                </div>
                            </div>



                                
                        </div>
                        <div class="modal-footer">
                            <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                            <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                        </div>
                    </div>
                </div>
            </div>
        <!-- ============================================================ EDIT DATA ======================================================================== -->


        </div>
      </div>

        </div>
      </section>
  </div>




</template>


<script>

// import Autocomplete from 'vue2-autocomplete-js'

const ADD_URL = URL_APP + 'api/v1/reg_modul_sakip/';

    export default {
      // components: { Autocomplete },
        name: 'monev_wilayah',
            data () {
            return {
                dataku: {
                  modul_sakip_id : '',
                  nama_modul : '',
                  akses_semua_unit : false,
                  registrator : false,
                  delegasi_lv_1 : false,
                  delegasi_lv_2 : false,
                  delegasi_lv_3 : false,
                  ra_lv_1 : false,
                  ra_lv_2 : false,
                  ra_lv_3 : false,
                  realisasi : false,
                  laporan : false

                },
                check_semua : false,
                list_data : [],
                page_first : 1,
                page_last : 0,
                cari_value : '',
            }
        },

        mounted : function(){
          this.getData();
          this.autocompleted();
        },

        methods : {
          getData : function(){

            fetch(ADD_URL+'view_data', {
              method : 'POST',
              headers : {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body : JSON.stringify({
                data_ke : this.page_first,
                cari_value : this.cari_value

              })
            }).then((res) => res.json())
              .then ((res_data) => {
                this.list_data = res_data;
                // this.page_last = res_data.jml_data
                console.log(res_data);
              })

          },

          addData : function(){
            fetch (ADD_URL+'create', {
              method : 'POST',
              headers : {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body : JSON.stringify(this.dataku)
            }).then(res => res.json())
              .then((res_wilayah) => {
                // this.list_wilayah.unshift(res_wilayah);
                // console.log(res_wilayah);
                this.getData();
                this.alertku('success', 'sukses menambah data')
              })
          },


          removeData : function(id){
            fetch(ADD_URL+'remove', {
              method : 'POST',
              headers : {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body : JSON.stringify({id : id})
            }).then((res_wilayah)=>{
              this.getData();
              this.alertku('success', 'sukses menghapus data')
            })
          },

          editData : function(){
            fetch (ADD_URL+'update', {
              method : 'POST',
              headers : {
                'content-type' : 'application/json',
                authorization : 'kikensbatara '+localStorage.token,
              },
              body : JSON.stringify(this.dataku)
            }).then((res_wilayah)=>{
              this.getData();
              this.alertku('success', 'sukses merubah data')
            })
          },

          selectData : function(data){
            console.log(data);
            this.dataku = {
                  modul_sakip_id : data.modul_sakip_id,
                  nama_modul : data.nama_modul,
                  akses_semua_unit : data.akses_semua_unit,
                  registrator : data.registrator,
                  delegasi_lv_1 : data.delegasi_lv_1,
                  delegasi_lv_2 : data.delegasi_lv_2,
                  delegasi_lv_3 : data.delegasi_lv_3,
                  ra_lv_1 : data.ra_lv_1,
                  ra_lv_2 : data.ra_lv_2,
                  ra_lv_3 : data.ra_lv_3,
                  realisasi : data.realisasi,
                  laporan : data.laporan

                }
          },

          autocompleted : function(){

            $.ajax({
              url: URL_APP+'api/v1/program/',
              type: "GET",
              headers : {
                'content-type' : 'application/json',
                authorization : 'kikensbatara '+localStorage.token,
              },
              success: function(result){
                horsey(document.querySelector('#instansi'), {
                  source: [{ list: result }],
                  getText: 'uraian',
                  getValue: 'uraian',
                  predictNextSearch(info) {
                    document.getElementById('id_instansi').value= info.selection._id ;
                    document.getElementById('id_ins').value= info.selection.uraian ;
                  },
                  limit: 2
                });
            }});

          },


          check_pilihan : function(){
                this.dataku.modul_sakip_id = this.check_semua;
                this.dataku.akses_semua_unit = this.check_semua;
                this.dataku.registrator = this.check_semua;
                this.dataku.delegasi_lv_1 = this.check_semua;
                this.dataku.delegasi_lv_2 = this.check_semua;
                this.dataku.delegasi_lv_3 = this.check_semua;
                this.dataku.ra_lv_1 = this.check_semua;
                this.dataku.ra_lv_2 = this.check_semua;
                this.dataku.ra_lv_3 = this.check_semua;
                this.dataku.realisasi = this.check_semua;
                this.dataku.laporan = this.check_semua;
          },






          // ================== PAGINASI ====================
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
              if(this.page_first>1){
                this.page_first--
              }else{
                this.page_first = 1;
              }
              this.getData();
            },

            btn_next : function(){
              if(this.page_first >= this.page_last){
                this.page_first == this.page_last
              }else{
                this.page_first++;
              }
              this.getData();
            },

            cari_data : function(){
              this.getData();
            },

          // ================== PAGINASI ====================
        },

    }
</script>
